export default __webpack_public_path__ + "images/d20f0f0bf7fbc15b2a01f83a56407f45-appearance.jpg";